export const SnsConnectProviderKind = {
  Instagram: 'instagram',
  Twitter: 'twitter',
  Youtube: 'google_oauth2',
  TikTok: 'tiktok',
} as const

export type SnsConnectProviderKind = (typeof SnsConnectProviderKind)[keyof typeof SnsConnectProviderKind]

export type SnsConnect = {
  id: number
  provider: SnsConnectProviderKind
  followerCount: number
  url: string
  name: string
  postCount: number
  isFacebookAuth: boolean
}
